import { Option } from '../constants/urls'

interface UrlParameters {
  mag?: any
  t?: Option
}

export function parseUrlParameters(): UrlParameters {
  const pl = /\+/g
  const search = /([^&=]+)=?([^&]*)/g
  const decode = (s: string): string => {
    return decodeURIComponent(s.replace(pl, ' '))
  }
  const query = window.location.search.substring(1)

  let urlParams: Record<string, any> = {} // ToDo: This cannot be good
  let match: RegExpExecArray | null
  while ((match = search.exec(query))) {
    urlParams[decode(match[1])] = decode(match[2])
  }

  return urlParams
}

export function stringifyUrlParameters(params: any) {
  return (
    '?' +
    Object.keys(params)
      .map((key) => {
        return key + '=' + encodeURIComponent(params[key])
      })
      .join('&')
  )
}

export function updateUrl(params: any) {
  const currentUrlParameters = parseUrlParameters()
  const combinedParams = {
    ...currentUrlParameters,
    ...params,
  }
  const newSearch = stringifyUrlParameters(combinedParams)
  if (window.history && window.history.replaceState) {
    window.history.replaceState(null, '', newSearch)
  }
}
